import { userProfileConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { updateDobInfoLoading: true, data: '', error: false };

export function updateDobInfo(state = initialState, action) {
    
    switch (action.type) {
        case userProfileConstants.REQUEST_UPDATE_DOB:
            return {
                updateDobInfoLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_UPDATE_DOB:
        swal({
            text: 'User Dob Profile Updated Successfully',
            type: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
            return {
                updateDobInfoLoading: false,
                data: action.updateDobInfo,
                error: false
            };
        case userProfileConstants.UPDATE_DOB_ERROR:
        swal({
            text: 'Error in updating user profile',
            type:'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
        })
            return {
                updateDobInfoLoading: false,
                data: action.error,
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/updateDobInfo.reducer.js